































































































































































































































































































































































import Vue, { PropType } from "vue";
import { createNamespacedHelpers } from "vuex";

import { Appointment, Client } from "@/types";
import appointmentStoreModule from "@/store/modules/appointment";
import moment from "moment-timezone";
import DateFilter from "./AppointmentDateFilter.vue";

const { mapActions: appointmentActions, mapGetters: appointmentGetters } =
  createNamespacedHelpers("APPOINTMENT_LIST");

export default Vue.extend<any, any, any, any>({
  name: "AppointmentList",
  components: {
    DateFilter,
  },
  props: {
    client: {
      type: Object as PropType<Client>,
    },
    status: {
      type: String,
    },
    paymentStatus: {
      type: String,
    },
    roomId: {
      type: String,
    },
    filterType: {
      type: String,
    },
    employeeId: {
      type: String,
    },
    startDate: {},
    endDate: {},
    showClient: {
      default: false,
    },
    showFilters: {
      default: true,
    },
    employees: {
      type: Array,
      default: () => [],
    },
    specificStartDate: {
      type: String,
      default: "",
    },
    specificEndDate: {
      type: String,
      default: "",
    },
    externalAppointmentPage: {
      type: Object,
      default: null,
    },
    externalCount: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    appointment: undefined,
    showDialog: false,
    showNotesDialog: false,
    editingNotes: false,
    notes: "",
    apiUrl: process.env.VUE_APP_API_URL,
    options: {} as { page: number },
  }),
  created() {
    // Only fetch appointments if no external appointment page is provided
    if (!this.externalAppointmentPage) {
      this.fetchAppointments();
    }
  },
  watch: {
    options: {
      handler() {
        console.log(this.options);
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    status: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    paymentStatus: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    roomId: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    startDate: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    filterType: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    employeeId: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    employees: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
      deep: true,
    },
    specificStartDate: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
    },
    specificEndDate: {
      handler() {
        if (!this.externalAppointmentPage) {
          this.fetchAppointments();
        }
      },
    },
    currentAppointmentCount: {
      handler(newCount: number) {
        this.$emit("count-updated", newCount);
      },
      immediate: true,
    },
    uniqueClientsCount: {
      handler(newCount: number) {
        this.$emit("unique-clients-updated", newCount);
      },
      immediate: true,
    },
  },
  computed: {
    ...appointmentGetters(["appointmentPage", "appointmentCount"]),
    currentAppointmentPage() {
      // Use external appointment page if provided, otherwise use the store appointment page
      return this.externalAppointmentPage || this.appointmentPage;
    },
    currentAppointmentCount() {
      // Use external count if provided, otherwise use the store appointment count
      return this.externalCount || this.appointmentCount;
    },
    uniqueClientsCount() {
      // Return from current appointment page if available, otherwise compute from docs
      const currentPage = this.currentAppointmentPage;
      if (currentPage.uniqueClientsCount !== undefined) {
        return currentPage.uniqueClientsCount;
      }
      // Fallback computation
      const uniqueClients = new Set();
      currentPage.docs.forEach((appointment) => {
        if (appointment.client && appointment.client._id) {
          uniqueClients.add(appointment.client._id);
        }
      });
      return uniqueClients.size;
    },
    headers() {
      if (this.showClient) {
        return [
          { text: "Client", value: "client" },
          {
            text: "Service",
            align: "start",
            sortable: true,
            value: "services",
          },
          { text: "Date", value: "date" },
          { text: "Time", value: "time" },

          { text: "Appointment Status", value: "status" },
          { text: "Payment Status", value: "paymentStatus" },
          { text: "Action", value: "action" },
        ];
      }
      return [
        {
          text: "Service",
          align: "start",
          sortable: true,
          value: "services",
        },
        { text: "Date", value: "date" },
        { text: "Time", value: "time" },
        { text: "Staff", value: "employee" },
        { text: "Appointment Status", value: "status" },
        { text: "Payment Status", value: "paymentStatus" },
        { text: "Action", value: "action" },
      ];
    },
  },
  methods: {
    ...appointmentActions([
      "fetchAppointmentList",
      "updateAppointment",
      "deleteAppointment",
      "fetchAppointmentCount",
    ]),

    getFirstAndLastDate(duration) {
      const currentDate = new Date();
      let firstDay = new Date(currentDate);
      let lastDay = new Date(currentDate);
      const dayOfWeek = currentDate.getDay();

      switch (duration.toLowerCase()) {
        case "month":
          // First day of the current month
          firstDay.setDate(1);
          // Last day is the first day of the next month
          lastDay.setMonth(currentDate.getMonth() + 1);
          lastDay.setDate(1);
          break;

        case "week":
          firstDay.setDate(currentDate.getDate() - dayOfWeek);
          lastDay.setDate(firstDay.getDate() + 6);
          break;
        default:
          // First and last day are the same for "day" and default cases
          firstDay = lastDay;
          break;
      }

      return {
        firstDay: firstDay.toISOString(),
        lastDay: lastDay.toISOString(),
      };
    },
    getLastDate(duration) {
      const currentDate = new Date();
      let endDate = new Date(currentDate);

      switch (duration.toLowerCase()) {
        case "month":
          endDate.setMonth(endDate.getMonth() + 1);
          break;
        case "week":
          endDate.setDate(endDate.getDate() + 7);
          break;
        case "category":
          endDate.setDate(endDate.getDate() + 1);
          break;
        default:
          endDate.setDate(endDate.getDate() + 1);
      }

      return endDate.toISOString();
    },
    saveNotes(id: string) {
      this.updateAppointment({ id, appointment: { notes: this.notes } });
    },
    fetchAppointments() {
      let params = `?businessId=${localStorage.getItem("businessId")}`;

      if (this.client) {
        params += `&clientId=${this.client._id}`;
      }

      if (this.options.itemsPerPage && this.options.itemsPerPage > 1) {
        params += `&limit=${this.options.itemsPerPage}`;
      }

      if (this.status && this.status.toLowerCase() != "all appointments") {
        params += `&status=${this.status.toLowerCase()}`;
      }

      if (
        this.paymentStatus &&
        this.paymentStatus.toLowerCase() != "all payments"
      ) {
        params += `&paymentStatus=${this.paymentStatus.toLowerCase()}`;
      }

      // Use specific dates if provided, otherwise use startDate/endDate props
      if (this.specificStartDate || this.specificEndDate) {
        if (this.specificStartDate) {
          const startDate = moment(this.specificStartDate)
            .startOf("day")
            .toISOString();
          params += `&startDate=${startDate}`;
        }
        if (this.specificEndDate) {
          const endDate = moment(this.specificEndDate)
            .endOf("day")
            .toISOString();
          params += `&endDate=${endDate}`;
        }
      } else {
        if (this.startDate) {
          params += `&startDate=${this.startDate.toISOString()}`;
        }
        if (this.endDate) {
          params += `&endDate=${this.endDate.toISOString()}`;
        }
      }

      if (this.employeeId) {
        params += `&employeeId=${this.employeeId}`;
      }

      if (this.employees && this.employees.length) {
        const employeeIds = this.employees
          .map((employee) => employee._id)
          .join("&employeeId=");
        params += `&employeeId=${employeeIds}`;
      }

      if (this.roomId) {
        params += `&roomId=${this.roomId}`;
      }

      if (this.options && this.options?.sortBy?.length) {
        var sortPrefix = this.options.sortDesc[0] ? "-" : "";
        let field = this.options.sortBy[0];
        if (field == "date" || field == "time") {
          field = "startDate";
        }
        params += `&sort=${sortPrefix}${field}`;
      }
      this.fetchAppointmentCount(`${params}`);

      this.fetchAppointmentList(params);
    },
    getEndDate(appointment: Appointment) {
      return moment(appointment.startDate)
        .add(appointment.durationInMinutes, "minutes")
        .toISOString();
    },
    exportCsv() {
      const headers = this.headers.map((header) => header.text).join(",");
      const rows = this.currentAppointmentPage.docs.map((appointment) => {
        const services = appointment.services
          .map((service) => service.name)
          .join(";");
        const employee = appointment.employee
          ? appointment.employee.fullName
          : "";
        const client = appointment.client ? appointment.client.fullName : "";
        const date = moment(appointment.startDate).format("D/MM/YYYY");
        const time = `${moment(appointment.startDate).format(
          "HH:mm"
        )} - ${moment(appointment.startDate)
          .add(appointment.durationInMinutes, "minutes")
          .format("HH:mm")}`;
        const status = appointment.status;
        const paymentStatus = appointment.paymentStatus;

        return `${client},${services},${date},${time},${employee},${status},${paymentStatus}`;
      });

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", "appointments.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getStatusColor(status: string) {
      switch (status?.toLowerCase()) {
        case "completed":
          return "success";
        case "pending":
          return "warning";
        case "cancelled":
          return "error";
        default:
          return "grey";
      }
    },
    getPaymentStatusColor(paymentStatus: string) {
      switch (paymentStatus?.toLowerCase()) {
        case "completed":
          return "success";
        case "pending":
          return "warning";
        case "cancelled":
        case "refunded":
          return "error";
        default:
          return "grey";
      }
    },
  },
  beforeCreate() {
    if (this.$store.hasModule("APPOINTMENT_LIST")) {
      this.$store.unregisterModule("APPOINTMENT_LIST");
    }
    this.$store.registerModule("APPOINTMENT_LIST", appointmentStoreModule);
  },
});
